import { FetchPsyCollectionResponse } from "utils/interfaces"
import { httpClient } from "utils/infrastructure/httpClient"

export function getPsyCollection(id: number) {
    return httpClient.get<FetchPsyCollectionResponse>(`psychologist/collection/${id}`)
}
